/*
  Turns Dawn's numeric gallery counter ("1 / 6") into dots.

  Dawn ships arrows plus a counter and has no dot indicator for the product
  gallery, so the dots are built here and kept in sync by watching the counter
  Dawn already maintains — cheaper and less brittle than re-deriving the active
  slide from scroll position, and it inherits Dawn's own logic for what counts
  as the current slide.
*/
(function () {
  function init() {
    var gallery = document.querySelector('.product__media-wrapper media-gallery');
    if (!gallery) return;

    var counter = gallery.querySelector('.slider-counter');
    var current = gallery.querySelector('.slider-counter--current');
    var total = gallery.querySelector('.slider-counter--total');
    var list = gallery.querySelector('.product__media-list');
    if (!counter || !current || !total || !list) return;

    // Count rendered slides, not Dawn's media_count: that total still includes
    // the size-chart image the gallery skips, so it ran one dot over.
    var slides = list.querySelectorAll('.product__media-item');
    var count = slides.length;
    if (count < 2) return;
    total.textContent = String(count);

    var dots = document.createElement('div');
    dots.className = 'fm-gallery-dots';
    dots.setAttribute('aria-hidden', 'true');

    for (var i = 0; i < count; i++) {
      var dot = document.createElement('span');
      dot.className = 'fm-gallery-dot';
      dots.appendChild(dot);
    }
    counter.parentNode.insertBefore(dots, counter);

    function sync() {
      var index = (parseInt(current.textContent, 10) || 1) - 1;
      var children = dots.children;
      for (var i = 0; i < children.length; i++) {
        children[i].classList.toggle('is-active', i === index);
      }
    }

    sync();
    new MutationObserver(sync).observe(current, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
